"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es6.reflect.construct.js");

require("core-js/modules/es6.symbol.js");

require("core-js/modules/es6.string.iterator.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.array.iterator.js");

require("core-js/modules/web.dom.iterable.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.replace.js");

require("core-js/modules/es6.object.set-prototype-of.js");

require("core-js/modules/es6.object.get-prototype-of.js");

var _react = _interopRequireDefault(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _utils = require("../../../lib/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var classNames = require('classnames');

require('../../../sass/components/shared/elements/ResourceListItem.css');

var ResourceListItem = /*#__PURE__*/function (_React$Component) {
  _inherits(ResourceListItem, _React$Component);

  var _super = _createSuper(ResourceListItem);

  function ResourceListItem() {
    _classCallCheck(this, ResourceListItem);

    return _super.apply(this, arguments);
  }

  _createClass(ResourceListItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isInternal = _this$props.isInternal,
          resourceData = _this$props.resourceData;
      var idx = resourceData.idx,
          title = resourceData.title,
          subtitle = resourceData.subtitle,
          filetype = resourceData.filetype,
          featured = resourceData.featured,
          createdAt = resourceData.createdAt,
          url = resourceData.url,
          isActive = resourceData.isActive,
          forFacing = resourceData.forFacing;
      var titleClasses = classNames('title', {
        featured: featured,
        disabled: !isActive
      });
      var gaTitle = title ? 'resource_' + title.replace(/ .*/, '') : '';
      var isNew = createdAt && (0, _moment.default)().diff(createdAt, 'days') < 30;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "content-wrapper"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "resource-list-item",
        key: idx
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "main-content"
      }, /*#__PURE__*/_react.default.createElement("a", {
        className: titleClasses,
        href: url,
        target: "_blank",
        onClick: !isInternal && (0, _utils.googleAnalytics)(gaTitle, 'button_press')
      }, title, isNew ? /*#__PURE__*/_react.default.createElement("span", {
        className: "new-tag tag-followed-up"
      }, " New ") : null, forFacing && forFacing === 'client' && /*#__PURE__*/_react.default.createElement("span", {
        className: "client-facing-tag"
      }, " Client Facing "), forFacing && forFacing === 'funeralHome' && /*#__PURE__*/_react.default.createElement("span", {
        className: "funeral-facing-tag"
      }, " Funeral Home-Facing ")), /*#__PURE__*/_react.default.createElement("p", {
        className: "subtitle"
      }, subtitle)), /*#__PURE__*/_react.default.createElement("div", {
        className: "normal-content"
      }, filetype), /*#__PURE__*/_react.default.createElement("div", {
        className: "normal-content content-links"
      }, /*#__PURE__*/_react.default.createElement("p", null, isInternal ? /*#__PURE__*/_react.default.createElement("a", {
        onClick: this.props.onEditClick,
        className: "pointer edit"
      }, "Edit") : /*#__PURE__*/_react.default.createElement("span", {
        className: "pointer"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: url,
        target: "_blank"
      }, filetype === 'Video' ? 'View' : 'Download'))))));
    }
  }]);

  return ResourceListItem;
}(_react.default.Component);

exports.default = ResourceListItem;